var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { SheetRowPredicateType, TagType } from '@common/api';
import { useTagContext } from '@data/tag/tagContext';
import FormInput from '@shared/forms/FormInput';
import { CheckBox } from '@shared/input/CheckBox';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import Tags from '@shared/tags/Tags';
import * as FarseerIcons from '@shared/icons/icons';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
import { ModalBody } from '@styled/Modal';
import React, { useState } from 'react';
import FSButton from '@components/FSButton';
import FSFormSection from '@components/FSFormSection';
import { mapSheetRowPredicateToPredicateRepresentation, toSheetRowPredicate, } from '@data/sheetRow/sheetRowPredicate';
import { useCreateSheetRow, useUpdateSheetRow } from '@data/sheetRow/sheetRowActions';
import { useSheetRowsById } from '@data/sheetRow/sheetRowHooks';
import { NEW_SHEET_ROW } from '../../../data/sheetRow/sheetRow';
function isNewSheetRow(sheetRow) {
    return !('id' in sheetRow);
}
function validate(sheetRow) {
    var errors = {};
    if (sheetRow.name === '') {
        errors.name = 'You must enter a title for the row';
    }
    var advancedFilter = getFilters(sheetRow).advancedFilter;
    var advancedFilterIds = getAdvancedFilterIds(advancedFilter);
    var emptyLeftFilter = advancedFilterIds.find(function (f) { return f.left === 0; });
    if (emptyLeftFilter !== undefined) {
        errors.downstreamFilters = 'From table field must not be empty in Downstream filter';
    }
    return errors;
}
//       total_filter => simple_filter | advanced_filter | AND(simple_filter,advanced_filter)
//      simple_filter => OR | AND(OR,OR)
//    advanced_filter => DS | AND(DS,DS,...)
// ===== all options:
// OR | AND(OR,OR) | DS             | AND(OR,DS)             | AND(AND(OR,OR),DS)
// OR | AND(OR,OR) | AND(DS,DS,...) | AND(OR,AND(DS,DS,...)) | AND(AND(OR,OR),AND(DS,DS,...))
function createPredicateTree(newSimpleFilterPredicate, newAdvancedFilterPredicate) {
    // no filters -> undefined
    // only one (simple or advanced) filter -> return that filter
    if (newSimpleFilterPredicate === undefined || newAdvancedFilterPredicate === undefined) {
        return newSimpleFilterPredicate !== null && newSimpleFilterPredicate !== void 0 ? newSimpleFilterPredicate : newAdvancedFilterPredicate;
    }
    // both filters -> AND(simple_filter,advanced_filter)
    return {
        type: SheetRowPredicateType.And,
        children: [newSimpleFilterPredicate, newAdvancedFilterPredicate],
    };
}
function getFilters(newSheetRow) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    // no filters
    if (newSheetRow.predicateTree === undefined || newSheetRow.predicateTree === null) {
        return { simpleFilter: undefined, advancedFilter: undefined };
    }
    // OR
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.Or) {
        return {
            simpleFilter: __assign({}, newSheetRow.predicateTree),
        };
    }
    // AND(OR,OR)
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.And &&
        ((_a = newSheetRow.predicateTree.children[0]) === null || _a === void 0 ? void 0 : _a.type) === SheetRowPredicateType.Or &&
        ((_b = newSheetRow.predicateTree.children[1]) === null || _b === void 0 ? void 0 : _b.type) === SheetRowPredicateType.Or) {
        return {
            simpleFilter: newSheetRow.predicateTree,
        };
    }
    // DS
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.Downstream) {
        return { advancedFilter: __assign({}, newSheetRow.predicateTree) };
    }
    // AND(DS,DS,...)
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.And &&
        newSheetRow.predicateTree.children.every(function (c) { return c.type === SheetRowPredicateType.Downstream; })) {
        return {
            advancedFilter: __assign({}, newSheetRow.predicateTree),
        };
    }
    // AND(OR,DS)
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.And &&
        ((_c = newSheetRow.predicateTree.children[0]) === null || _c === void 0 ? void 0 : _c.type) === SheetRowPredicateType.Or &&
        ((_d = newSheetRow.predicateTree.children[1]) === null || _d === void 0 ? void 0 : _d.type) === SheetRowPredicateType.Downstream) {
        return {
            simpleFilter: __assign({}, newSheetRow.predicateTree.children[0]),
            advancedFilter: newSheetRow.predicateTree.children[1],
        };
    }
    // AND(OR,AND(DS,DS,...))
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.And &&
        ((_e = newSheetRow.predicateTree.children[0]) === null || _e === void 0 ? void 0 : _e.type) === SheetRowPredicateType.Or &&
        ((_f = newSheetRow.predicateTree.children[1]) === null || _f === void 0 ? void 0 : _f.type) === SheetRowPredicateType.And &&
        ((_g = newSheetRow.predicateTree.children[1]) === null || _g === void 0 ? void 0 : _g.children.every(function (c) { return c.type === SheetRowPredicateType.Downstream; }))) {
        return {
            simpleFilter: __assign({}, newSheetRow.predicateTree.children[0]),
            advancedFilter: newSheetRow.predicateTree.children[1],
        };
    }
    // AND(AND(OR,OR),DS)
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.And &&
        ((_h = newSheetRow.predicateTree.children[0]) === null || _h === void 0 ? void 0 : _h.type) === SheetRowPredicateType.And &&
        ((_k = (_j = newSheetRow.predicateTree.children[0]) === null || _j === void 0 ? void 0 : _j.children[0]) === null || _k === void 0 ? void 0 : _k.type) === SheetRowPredicateType.Or &&
        ((_m = (_l = newSheetRow.predicateTree.children[0]) === null || _l === void 0 ? void 0 : _l.children[1]) === null || _m === void 0 ? void 0 : _m.type) === SheetRowPredicateType.Or &&
        ((_o = newSheetRow.predicateTree.children[1]) === null || _o === void 0 ? void 0 : _o.type) === SheetRowPredicateType.Downstream) {
        return {
            simpleFilter: newSheetRow.predicateTree.children[0],
            advancedFilter: newSheetRow.predicateTree.children[1],
        };
    }
    // AND(AND(OR,OR),AND(DS,DS,...))
    if (newSheetRow.predicateTree.type === SheetRowPredicateType.And &&
        ((_p = newSheetRow.predicateTree.children[0]) === null || _p === void 0 ? void 0 : _p.type) === SheetRowPredicateType.And &&
        ((_r = (_q = newSheetRow.predicateTree.children[0]) === null || _q === void 0 ? void 0 : _q.children[0]) === null || _r === void 0 ? void 0 : _r.type) === SheetRowPredicateType.Or &&
        ((_t = (_s = newSheetRow.predicateTree.children[0]) === null || _s === void 0 ? void 0 : _s.children[1]) === null || _t === void 0 ? void 0 : _t.type) === SheetRowPredicateType.Or &&
        ((_u = newSheetRow.predicateTree.children[1]) === null || _u === void 0 ? void 0 : _u.type) === SheetRowPredicateType.And &&
        ((_v = newSheetRow.predicateTree.children[1]) === null || _v === void 0 ? void 0 : _v.children.every(function (c) { return c.type === SheetRowPredicateType.Downstream; }))) {
        return {
            simpleFilter: newSheetRow.predicateTree.children[0],
            advancedFilter: newSheetRow.predicateTree.children[1],
        };
    }
    // unsupported option
    return { simpleFilter: undefined, advancedFilter: undefined };
}
function toDimensionTagIds(c) {
    return c.type === SheetRowPredicateType.DimensionTag ? c.dimensionTagId : 0;
}
function getSimpleFilterIds(filterPredicate) {
    // OR
    if ((filterPredicate === null || filterPredicate === void 0 ? void 0 : filterPredicate.type) === SheetRowPredicateType.Or) {
        return {
            left: filterPredicate.children.map(toDimensionTagIds),
        };
    }
    // AND(OR,OR)
    if ((filterPredicate === null || filterPredicate === void 0 ? void 0 : filterPredicate.children[0].type) === SheetRowPredicateType.Or &&
        (filterPredicate === null || filterPredicate === void 0 ? void 0 : filterPredicate.children[1].type) === SheetRowPredicateType.Or) {
        return {
            left: filterPredicate.children[0].children.map(toDimensionTagIds),
            right: filterPredicate.children[1].children.map(toDimensionTagIds),
        };
    }
    return { left: undefined, right: undefined };
}
function getAdvancedFilterIds(filterPredicate) {
    // DS
    if ((filterPredicate === null || filterPredicate === void 0 ? void 0 : filterPredicate.type) === SheetRowPredicateType.Downstream) {
        return [{ left: filterPredicate.fromTableTagId, right: filterPredicate.toTableTagId }];
    }
    // AND(DS,DS,...)
    if ((filterPredicate === null || filterPredicate === void 0 ? void 0 : filterPredicate.type) === SheetRowPredicateType.And &&
        filterPredicate.children.every(function (c) { return c.type === SheetRowPredicateType.Downstream; })) {
        return filterPredicate.children.map(function (c) { return ({
            left: c.fromTableTagId,
            right: c.toTableTagId,
        }); });
    }
    // no filter
    return [];
}
function getFilterTags(filterTagIds, tagMap) {
    var e_1, _a;
    if (filterTagIds === void 0) { filterTagIds = []; }
    var filterTags = [];
    try {
        for (var filterTagIds_1 = __values(filterTagIds), filterTagIds_1_1 = filterTagIds_1.next(); !filterTagIds_1_1.done; filterTagIds_1_1 = filterTagIds_1.next()) {
            var id = filterTagIds_1_1.value;
            var tag = tagMap[id];
            if (tag) {
                filterTags.push(tag);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (filterTagIds_1_1 && !filterTagIds_1_1.done && (_a = filterTagIds_1.return)) _a.call(filterTagIds_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return filterTags;
}
function RowForm(props) {
    var _a, _b, _c;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var sheetRowsById = useSheetRowsById();
    var updateSheetRow = useUpdateSheetRow();
    var createSheetRow = useCreateSheetRow();
    var _d = __read(useState(false), 2), showAdvanced = _d[0], setShowAdvanced = _d[1];
    var _e = __read(useState({}), 2), errors = _e[0], setErrors = _e[1];
    var _f = __read(useState(function () {
        var _a;
        var sheetRow = sheetRowsById[(_a = props.sheetRowId) !== null && _a !== void 0 ? _a : 0];
        if (!props.sheetRowId || !sheetRow) {
            return __assign({}, NEW_SHEET_ROW);
        }
        return __assign(__assign({}, sheetRow), { predicateTree: toSheetRowPredicate(sheetRow.predicate) });
    }), 2), newSheetRow = _f[0], setNewSheetRow = _f[1];
    var tableTag = tagData.tagById[(_a = newSheetRow.tableTagId) !== null && _a !== void 0 ? _a : 0];
    var _g = getFilters(newSheetRow), simpleFilter = _g.simpleFilter, advancedFilter = _g.advancedFilter;
    var simpleFilterIds = getSimpleFilterIds(simpleFilter);
    var simpleLeftFilterTags = getFilterTags((_b = simpleFilterIds.left) !== null && _b !== void 0 ? _b : [], tagData.tagById);
    var simpleRightFilterTags = getFilterTags((_c = simpleFilterIds.right) !== null && _c !== void 0 ? _c : [], tagData.tagById);
    var advancedFilterIds = getAdvancedFilterIds(advancedFilter);
    function done() {
        var errors = validate(newSheetRow);
        if (Object.keys(errors).length) {
            setErrors(errors);
            return;
        }
        var sheetRowCopy = __assign({}, newSheetRow);
        var predicates = null;
        if (sheetRowCopy.predicateTree) {
            predicates = mapSheetRowPredicateToPredicateRepresentation(sheetRowCopy.predicateTree);
        }
        sheetRowCopy.predicate = predicates;
        var mutationOptions = {
            onSuccess: function () {
                Manager.closeModal();
            },
        };
        if (isNewSheetRow(sheetRowCopy)) {
            createSheetRow.mutate(sheetRowCopy, mutationOptions);
            return;
        }
        updateSheetRow.mutate(sheetRowCopy, mutationOptions);
    }
    function setSimpleFilter(newSimpleFilterPredicate) {
        setNewSheetRow(__assign(__assign({}, newSheetRow), { predicateTree: createPredicateTree(newSimpleFilterPredicate, advancedFilter) }));
    }
    function selectSimpleLeftFilterTag(tagId) {
        var newDimensionFilter = {
            type: SheetRowPredicateType.DimensionTag,
            dimensionTagId: tagId,
        };
        if (simpleFilter === undefined) {
            // no filter -> OR
            setSimpleFilter({ type: SheetRowPredicateType.Or, children: [newDimensionFilter] });
            return;
        }
        var simpleFilterPredicateCopy = __assign({}, simpleFilter);
        if (simpleFilterPredicateCopy.type === SheetRowPredicateType.Or) {
            // OR
            simpleFilterPredicateCopy.children = __spreadArray(__spreadArray([], __read(simpleFilterPredicateCopy.children), false), [newDimensionFilter], false);
            setSimpleFilter(simpleFilterPredicateCopy);
            return;
        }
        if (simpleFilterPredicateCopy.type === SheetRowPredicateType.And) {
            // AND(OR,OR)
            simpleFilterPredicateCopy.children[0].children = __spreadArray(__spreadArray([], __read(simpleFilterPredicateCopy.children[0].children), false), [
                newDimensionFilter,
            ], false);
            setSimpleFilter(simpleFilterPredicateCopy);
            return;
        }
    }
    function removeSimpleLeftFilterTag(tagId) {
        if (simpleFilter === undefined) {
            // no filter
            return;
        }
        var simpleFilterPredicateCopy = __assign({}, simpleFilter);
        if (simpleFilterPredicateCopy.type === SheetRowPredicateType.Or) {
            // OR -> OR | no filter (if no tags left)
            var filtered = simpleFilterPredicateCopy.children.filter(function (c) { return c.type === SheetRowPredicateType.DimensionTag && c.dimensionTagId !== tagId; });
            simpleFilterPredicateCopy.children = filtered;
            var newPredicateFilter = simpleFilterPredicateCopy.children.length > 0 ? simpleFilterPredicateCopy : undefined;
            setSimpleFilter(newPredicateFilter);
            return;
        }
        if (simpleFilterPredicateCopy.type === SheetRowPredicateType.And) {
            // AND(OR,OR) -> AND(OR,OR) | no filter
            var filtered = simpleFilterPredicateCopy.children[0].children.filter(function (c) { return c.type === SheetRowPredicateType.DimensionTag && c.dimensionTagId !== tagId; });
            simpleFilterPredicateCopy.children[0].children = filtered;
            var newPredicateFilter = simpleFilterPredicateCopy.children[0].children.length > 0 ? simpleFilterPredicateCopy : undefined;
            setSimpleFilter(newPredicateFilter);
            return;
        }
    }
    function selectSimpleRightFilterTag(tagId) {
        if (simpleFilter === undefined) {
            // no filter
            return;
        }
        var newDimensionFilter = {
            type: SheetRowPredicateType.DimensionTag,
            dimensionTagId: tagId,
        };
        if (simpleFilter.type === SheetRowPredicateType.Or) {
            // OR -> AND(OR,OR)
            setSimpleFilter({
                type: SheetRowPredicateType.And,
                children: [simpleFilter, { type: SheetRowPredicateType.Or, children: [newDimensionFilter] }],
            });
            return;
        }
        var simpleFilterPredicateCopy = __assign({}, simpleFilter);
        if (simpleFilterPredicateCopy.type === SheetRowPredicateType.And &&
            simpleFilter.children[1].type === SheetRowPredicateType.Or) {
            simpleFilterPredicateCopy.children[1].children = __spreadArray(__spreadArray([], __read(simpleFilterPredicateCopy.children[1].children), false), [
                newDimensionFilter,
            ], false);
            setSimpleFilter(simpleFilterPredicateCopy);
            return;
        }
    }
    function removeSimpleRightFilterTag(tagId) {
        if (simpleFilter === undefined || simpleFilter.type !== SheetRowPredicateType.And) {
            // no filter
            return;
        }
        var simpleFilterPredicateCopy = __assign({}, simpleFilter);
        var filtered = simpleFilterPredicateCopy.children[1].children.filter(function (c) { return c.type === SheetRowPredicateType.DimensionTag && c.dimensionTagId !== tagId; });
        if (filtered.length === 0) {
            // AND(OR,OR) -> OR
            setSimpleFilter(simpleFilterPredicateCopy.children[0]);
            return;
        }
        simpleFilterPredicateCopy.children[1].children = filtered;
        setSimpleFilter(simpleFilterPredicateCopy);
    }
    function setAdvancedFilter(newAdvancedFilterPredicate) {
        setNewSheetRow(__assign(__assign({}, newSheetRow), { predicateTree: createPredicateTree(simpleFilter, newAdvancedFilterPredicate) }));
    }
    function addDownstreamFilterToAdvancedFilter() {
        if (advancedFilter === undefined) {
            // no filter -> DS
            setAdvancedFilter({ type: SheetRowPredicateType.Downstream, fromTableTagId: 0, toTableTagId: 0 });
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.Downstream) {
            // DS -> AND(DS,DS,...)
            setAdvancedFilter({
                type: SheetRowPredicateType.And,
                children: [
                    advancedFilter,
                    { type: SheetRowPredicateType.Downstream, fromTableTagId: 0, toTableTagId: 0 },
                ],
            });
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.And) {
            // AND(DS,DS,...)
            setAdvancedFilter({
                type: SheetRowPredicateType.And,
                children: __spreadArray(__spreadArray([], __read(advancedFilter.children), false), [
                    { type: SheetRowPredicateType.Downstream, fromTableTagId: 0, toTableTagId: 0 },
                ], false),
            });
            return;
        }
    }
    function removeDownstreamFilterFromAdvancedFilter(idx) {
        if (advancedFilter === undefined) {
            // no filter
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.Downstream) {
            // DS -> no filter (if there is only one DS filter, remove it from predicate)
            setAdvancedFilter(undefined);
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.And) {
            // AND(DS,DS,DS...) -> AND(DS,DS,...) | DS (if only one DS filter is left)
            var filteredChildren = advancedFilter.children.filter(function (child, childIdx) { return childIdx !== idx; });
            if (filteredChildren.length === 1) {
                setAdvancedFilter(__assign({}, filteredChildren[0]));
            }
            else {
                setAdvancedFilter(__assign(__assign({}, advancedFilter), { children: filteredChildren }));
            }
            return;
        }
    }
    function selectAdvancedLeftFilterTag(idx, tagId) {
        if (advancedFilter === undefined) {
            // no filter -> DS
            setAdvancedFilter({
                type: SheetRowPredicateType.Downstream,
                fromTableTagId: tagId,
                toTableTagId: 0,
            });
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.Downstream && idx === 0) {
            // DS
            setAdvancedFilter(__assign(__assign({}, advancedFilter), { fromTableTagId: tagId }));
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.And) {
            // AND(DS,DS,...)
            var updatedChildren = advancedFilter.children.map(function (child, childIdx) {
                return childIdx === idx ? __assign(__assign({}, child), { fromTableTagId: tagId }) : child;
            });
            setAdvancedFilter({
                type: SheetRowPredicateType.And,
                children: updatedChildren,
            });
            return;
        }
    }
    function removeAdvancedLeftFilterTag(idx) {
        if (advancedFilter === undefined) {
            // no filter
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.Downstream && idx === 0) {
            // DS
            setAdvancedFilter(__assign(__assign({}, advancedFilter), { fromTableTagId: 0 }));
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.And) {
            // AND(DS,DS,...)
            var updatedChildren = advancedFilter.children.map(function (child, childIdx) {
                return childIdx === idx ? __assign(__assign({}, child), { fromTableTagId: 0 }) : child;
            });
            setAdvancedFilter({
                type: SheetRowPredicateType.And,
                children: updatedChildren,
            });
            return;
        }
    }
    function selectAdvancedRightFilterTag(idx, tagId) {
        if (advancedFilter === undefined) {
            // no filter -> DS
            setAdvancedFilter({
                type: SheetRowPredicateType.Downstream,
                fromTableTagId: 0,
                toTableTagId: tagId,
            });
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.Downstream && idx === 0) {
            // DS
            setAdvancedFilter(__assign(__assign({}, advancedFilter), { toTableTagId: tagId }));
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.And) {
            // AND(DS,DS,...)
            var updatedChildren = advancedFilter.children.map(function (child, childIdx) {
                return childIdx === idx ? __assign(__assign({}, child), { toTableTagId: tagId }) : child;
            });
            setAdvancedFilter({
                type: SheetRowPredicateType.And,
                children: updatedChildren,
            });
            return;
        }
    }
    function removeAdvancedRightFilterTag(idx) {
        if (advancedFilter === undefined) {
            // no filter
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.Downstream && idx === 0) {
            // DS
            setAdvancedFilter(__assign(__assign({}, advancedFilter), { toTableTagId: 0 }));
            return;
        }
        if (advancedFilter.type === SheetRowPredicateType.And) {
            // AND(DS,DS,...)
            var updatedChildren = advancedFilter.children.map(function (child, childIdx) {
                return childIdx === idx ? __assign(__assign({}, child), { toTableTagId: 0 }) : child;
            });
            setAdvancedFilter({
                type: SheetRowPredicateType.And,
                children: updatedChildren,
            });
            return;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Table')),
                    React.createElement(Tags, { tags: tableTag ? [tableTag] : [], select: function (tagId) {
                            var newTableTag = tagData.tagById[tagId];
                            if (newTableTag) {
                                setNewSheetRow(__assign(__assign({}, newSheetRow), { tableTagId: newTableTag.id }));
                            }
                        }, remove: function () { return setNewSheetRow(__assign(__assign({}, newSheetRow), { tableTagId: null })); }, filterByTypes: [TagType.Table], hideAddButton: !!tableTag })),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Filter')),
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(Tags, { tags: simpleLeftFilterTags, select: selectSimpleLeftFilterTag, remove: removeSimpleLeftFilterTag, filterByTypes: [TagType.Dimension] }),
                        simpleLeftFilterTags.length > 0 ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { style: { padding: '2px 8px 0px', fontSize: '13px', height: '29px' } }, L('and')),
                            React.createElement(Tags, { tags: simpleRightFilterTags, select: selectSimpleRightFilterTag, remove: removeSimpleRightFilterTag, filterByTypes: [TagType.Dimension] }))) : null)),
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: function () {
                            return setNewSheetRow(function (current) { return (__assign(__assign({}, current), { withData: !current.withData })); });
                        }, checked: newSheetRow.withData, label: L('Only with data') })),
                React.createElement(FSFormSection, { show: showAdvanced, title: L('Advanced'), onClick: function () { return setShowAdvanced(!showAdvanced); }, style: { marginTop: 30, marginBottom: 10 } },
                    React.createElement(FormField, { "$bottomSpace": true },
                        React.createElement(FormFieldLabel, null, L('Downstream Filters')),
                        advancedFilterIds.map(function (filterIds, idx) {
                            var _a, _b;
                            var advancedLeftFilterTag = tagData.tagById[(_a = filterIds.left) !== null && _a !== void 0 ? _a : 0];
                            var advancedRightFilterTag = tagData.tagById[(_b = filterIds.right) !== null && _b !== void 0 ? _b : 0];
                            return (React.createElement("div", { style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
                                React.createElement("div", { style: { padding: '2px 8px 0px', fontSize: '12px' } }, L('From table')),
                                React.createElement(Tags, { tags: advancedLeftFilterTag ? [advancedLeftFilterTag] : [], select: function (tagId) { return selectAdvancedLeftFilterTag(idx, tagId); }, remove: function () { return removeAdvancedLeftFilterTag(idx); }, filterByTypes: [TagType.Table], hideAddButton: advancedLeftFilterTag !== undefined }),
                                React.createElement("div", { style: { padding: '2px 8px 0px', fontSize: '12px' } }, L('To table')),
                                React.createElement(Tags, { tags: advancedRightFilterTag ? [advancedRightFilterTag] : [], select: function (tagId) { return selectAdvancedRightFilterTag(idx, tagId); }, remove: function () { return removeAdvancedRightFilterTag(idx); }, filterByTypes: [TagType.Table], hideAddButton: advancedRightFilterTag !== undefined }),
                                React.createElement(FSButton, { type: "button", "$color": "error", "$type": "tertiary", icon: FarseerIcons.Delete, style: { marginLeft: '32px' }, onClick: function () { return removeDownstreamFilterFromAdvancedFilter(idx); } })));
                        }),
                        React.createElement(FSButton, { type: "button", "$color": "primary", "$type": "tertiary", icon: FarseerIcons.Plus, onClick: function () { return addDownstreamFilterToAdvancedFilter(); }, style: { marginTop: '8px' }, title: L('Add Downstream Filter') })),
                    errors.downstreamFilters && (React.createElement(FormFieldErrorHelp, { style: { marginTop: '10px' } }, errors.downstreamFilters)),
                    React.createElement(FormField, null,
                        React.createElement(CheckBox, { action: function () {
                                return setNewSheetRow(function (current) { return (__assign(__assign({}, current), { hierarchyFlatten: !current.hierarchyFlatten })); });
                            }, checked: newSheetRow.hierarchyFlatten, label: L('Flat') })),
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { name: "depth", label: L('Hierarchy max depth'), value: newSheetRow.hierarchyMaxDepth, onChange: function (e) {
                                var newDepth = Number(e.target.value);
                                if (Number.isInteger(newDepth)) {
                                    setNewSheetRow(function (current) { return (__assign(__assign({}, current), { hierarchyMaxDepth: newDepth })); });
                                }
                            } }))),
                errors.message && (React.createElement(FormFieldErrorHelp, { style: { marginTop: '10px' } }, errors.message)))),
        React.createElement(ModalFooter, { loading: createSheetRow.isLoading || updateSheetRow.isLoading, done: done })));
}
function RowModal(props) {
    var L = useLanguage().L;
    var title = 'sheetRowId' in props ? (React.createElement("span", null,
        L('Editing row '),
        " ",
        React.createElement("b", null, props.sheetRowId))) : (React.createElement("span", null, L('New row')));
    return (React.createElement(Modal, { width: "500" },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(RowForm, __assign({}, props))));
}
export default RowModal;
